export default __webpack_public_path__ + "static/media/cat_face.b2c92744.svg";